module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptors"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/object/get-own-property-descriptors.js
// module id = 896
// module chunks = 2